<md-dialog>
	<div md-dialog-header>
		<div class="dialog-header">
			<div class="md-text-lg-semibold">{{ integrationDetails()?.entityName }} Integration Ids</div>
			<div class="guid-display">
				<span class="guid-text">{{ entityGuid() }}</span>
				<lb-copy-to-clipboard [textToCopy]="entityGuid()" [showConfirmation]="true" confirmationText="GUID copied!"></lb-copy-to-clipboard>
			</div>
		</div>
	</div>

	<div class="dialog-content">
		@if (isLoading()) {
			<lb-loader message="Loading integration details..."></lb-loader>
		} @else if (error()) {
			<div class="error-state">
				<p class="error-message">{{ error() }}</p>
				<button md-button (click)="loadData()">Retry</button>
			</div>
		} @else {
			<div class="integration-content">
				<!-- Connected Applications -->
				<div class="applications-section">
					<div class="section-header">
						@if (!readonly()) {
							<div class="section-actions">
								<md-button-group [value]="isEditing() ? 'edit' : 'view'" (change)="toggleEditMode($event)">
									<md-button-toggle value="view">View</md-button-toggle>
									<md-button-toggle value="edit">Edit</md-button-toggle>
								</md-button-group>
							</div>
						}
					</div>

					@if (integrationDetails()?.applications?.length === 0) {
						<div class="empty-state">
							<p>No applications connected to this integration.</p>
							@if (!readonly()) {
								<button md-button (click)="startEditing()">Add First Application</button>
							}
						</div>
					} @else {
						<div class="applications-list">
							@for (app of integrationDetails()?.applications; track app.applicationName) {
								<div class="application-item">
									<lb-form-field>
										<label>{{ getApplicationTypeName(app.applicationType) }} {{ app.columnName }}:</label>
										@if (isEditing()) {
											<div class="input-with-button">
												<input
													type="text"
													md-form-input
													[ngModel]="getEditValue(app.applicationName)"
													[disabled]="app.applicationType === 1"
													(ngModelChange)="setEditValue(app.applicationName, $event)"
													placeholder="Application Value (e.g., ID, URL)"
												/>
												<button
													md-button
													(click)="saveApplicationEdit(app.applicationName)"
													[disabled]="isSaving() || app.applicationType === 1"
												>
													@if (isSaving()) {
														Saving...
													} @else {
														Save
													}
												</button>
											</div>
										} @else {
											<div class="application-value">
												<span class="value-text">{{ app.applicationValue }}</span>
												<lb-copy-to-clipboard
													[textToCopy]="app.applicationValue"
													[showConfirmation]="true"
													confirmationText="Value copied!"
												></lb-copy-to-clipboard>
											</div>
										}
									</lb-form-field>
								</div>
							}
						</div>
					}

					<!-- Add New Application Form -->
					@if (isEditing() && showAddForm()) {
						<div class="add-application-form">
							<div class="form-header">Add New Application</div>
							<lb-form-field>
								<label>Application Type:</label>
								<md-drop-down
									[options]="applicationTypeOptions()"
									[value]="newApplicationType()"
									(change)="onApplicationTypeChange($event)"
									placeholder="Select Application Type"
								></md-drop-down>
							</lb-form-field>
							<lb-form-field>
								<label>{{ newApplicationValueLabel() }}</label>
								<input
									type="text"
									md-form-input
									[ngModel]="newApplicationValue()"
									(ngModelChange)="newApplicationValue.set($event)"
									placeholder="Application Value (e.g., ID, URL)"
								/>
							</lb-form-field>
							<div class="form-actions">
								<button md-button [disabled]="!canSave() || isSaving()" (click)="saveNewApplication()">
									@if (isSaving()) {
										Saving...
									} @else {
										Save
									}
								</button>
								<button md-button (click)="cancelAddForm()" [disabled]="isSaving()">Cancel</button>
							</div>
						</div>
					}

					@if (isEditing() && !showAddForm()) {
						<div class="add-new-section">
							@if (!noRemainingApplicationTypes()) {
								<button md-button (click)="showAddApplicationForm()" class="add-button" [disabled]="noRemainingApplicationTypes()">
									<md-icon iconUrl="untitled-ui/general/plus"></md-icon>
									Add Application
								</button>
							} @else {
								<div class="no-more-applications">All application types have been added.</div>
							}
						</div>
					}
				</div>
			</div>
		}
	</div>

	<div md-dialog-footer>
		<button md-button (click)="close()">Close</button>
	</div>
</md-dialog>
